<template>
  <div class="bg-video">
    <video class="bg-video__content" :key="videoSource" muted loop autoplay>
      <source :src="videoSource" type="video/mp4" />
      <!-- <source src="img/video.webm" type="video/webm" /> -->
      Your browser is not supported!
    </video>
  </div>
</template>

<script>
export default {
  props: ["videoSource"],
}
</script>

<style lang="scss" scoped>
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  opacity: .7;
  overflow: hidden;

  &__content {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
</style>
